import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { FlightSearchRecommendation } from 'shared/api/avia/flight-searches'
import { RecentSearchCard } from 'shared/ui/recent-search-card'

import { getInfoPrevSearches } from '../../lib/map-recommendation-to-form'

import { RecentSearchesSectionSkeleton } from './recent-searches-section-skeleton'
import s from './styles.module.scss'

interface Props {
  isLoading?: boolean
  items: FlightSearchRecommendation[] | null
  onRepeatSearch?: (item: FlightSearchRecommendation) => void
}

export const RecentSearchesSection = ({
  items,
  isLoading,
  onRepeatSearch,
}: Props) => {
  const { t } = useTranslation()

  const actualItems = useMemo(() => getInfoPrevSearches(items), [items])

  const onRepeatSearchHandler = (index: number) => {
    if (!items?.[index]) return

    onRepeatSearch?.(items[index])
  }

  const showSkeleton = isLoading && items === null

  if (!actualItems.length && !showSkeleton) {
    return null
  }

  return (
    <div className="container">
      <p className={clsx(s.title, 'bold-20')}>{t('recent_searches_title')}</p>

      {showSkeleton && (
        <div
          className={s.wrapperSkeleton}
          data-testid="recent-searches-skeletons"
        >
          <RecentSearchesSectionSkeleton />
          <RecentSearchesSectionSkeleton />
        </div>
      )}

      {actualItems.map((searches, index) => {
        return (
          <div
            className={s.item}
            key={index}
          >
            <RecentSearchCard
              title={searches.title}
              subtitle={searches.subtitle}
              onClick={() => onRepeatSearchHandler?.(index)}
            />
          </div>
        )
      })}
    </div>
  )
}
